"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ThemeOption_1 = require("./ThemeOption");
exports.ThemeOption = ThemeOption_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/general/owa-theme-option/lib/index.js
// module id = 4955
// module chunks = 2